import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';

import { convertLangCodeToSingleLetter, pushToGTMDataLayer, handleAnalyticsTrackingCodes } from '../../../utils/helpers';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import { languageController } from '../../../controllers/language/languageController';
import pidController from '../../../controllers/pidController';
import { useForm } from '../../../hooks/useForm';

import Select from '../../1_Atoms/Forms/Select/Select';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import Form from '../../2_Molecules/Form/Form';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';

function KMI({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [modelOptions, setModelOptions] = useState([]);
  const [formError, setFormError] = useState(null)
	 const [name, setfirstName] = useState('');
  //const [optin, setOptin] = useState(false);
  const [isDisabled, setIsDisabled] = useState('disabled')

  const { language, year, model, model_list, evFlag, source, formHeading, formImage, formDisclaimer, formSubmitButtonText } = formExtraParams

  // True if model name and year are provided from parent hidden inputs.
  const hasModelData = (model && year)

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    modelData: hasModelData ? [year, model].join(' ') : '',
    evFlag: false
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    postalcode: ['required', 'postalcode'],
    modelData: ['required'],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        const endPointUrl = getEndpointUrl('kmi');
        const modelDataArr = data.modelData.split(" ");
        // Other data to be sent
        const otherData = {
          language: convertLangCodeToSingleLetter(language),
          pid: pidController.getPid('kmi'),
          source: source,
          year: modelDataArr[0],
          model: modelDataArr.slice(1).join(' '),
          evFlag: evFlag ? evFlag === 'true' : initState.evFlag
        }

        // Remove whitespace in postalcode
        if (data.postalcode) {
          data.postalcode = data.postalcode.replace(/ /g, "");
        }

        // Remove modelData as no longer needed
        const { modelData, ...restData } = data

        const res = await handleRequest('post', endPointUrl, { ...restData, ...otherData });

        if (res.Success) {
			    setfirstName(firstname);
          setIsSubmitted(true);
          pushToGTMDataLayer({ formevent: 'submit' });
          handleAnalyticsTrackingCodes({ ...data, modelYear: modelDataArr[0], modelCarlineName: modelDataArr.slice(1).join(' ') }, 'Form Submit', 'Keep Me Informed', 'KMI');
          setData(initState);
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  useEffect(() => {
    async function fetchMazdaModels() {
      try {
        const res = await handleRequest('get', getEndpointUrl('model-years'));

        if (res.status === 200 && res.data) {
          const modelList = res.data['model_years'];

          if (!modelList) return;
          const mappedList = modelList.map(modelData => {
            const optionValue = [modelData.year?.title, modelData.carline?.voi_leads_name].join(' ')
            const optionContent = [modelData.year?.title, modelData.carline?.title].join(' ')
            return ({
              value: optionValue,
              label: optionContent
            })
          })

          setModelOptions(mappedList)
        }
      } catch (err) {
        console.log(err)
      }
    }

    // If "model" data (year + model name) is not provided from the parent inputs
    // get the model list from the api.
    if (!hasModelData) {
      fetchMazdaModels()
    }
  }, [])

  const { firstname, lastname, email, postalcode, modelData } = data;

  let selectedOptions;
  
  if(model_list != undefined){
    selectedOptions = modelOptions.filter((vehicle, index)=>{
      if(model_list.split(',').includes(modelOptions[index].value)) return modelOptions[index]
      return null
    });
  }
  return (
    <div
      className="mz-kmi"
      style={{ backgroundImage: formImage ? `url(${formImage})` : '' }}
    >
      <div className="mz-kmi__inner">
        <div className="mz-container">
          <div className="mz-full-width grid-inner-2-10-md grid-inner-4-6-lg">
            <FormContainer
              isSubmitted={isSubmitted}
              confirmation={(
                <FormConfirmation
                  heading={languageController.getCopy('kmi', 'confirmationHeading')}
                  subHeading={languageController.getCopy('kmi', 'confirmationSubHeading')}
				  firstName={name}
                  onClick={() => setIsSubmitted(false)}
                  isDark={true}
                />
              )}
              heading={formHeading ? parse(formHeading) : ''}
            >
              <Form
                type="kmi"
                onSubmit={handleSubmit}
                isDark={true}
                noValidate={true}
                errorMessage={formError}
              >
                {!hasModelData && (
                  <Select
                    name="modelData"
                    label={languageController.getFormCopy('label', 'model')}
                    value={modelData}
                    isRequired={true}
                    errorMessage={errors.modelData}
                    onChange={handleChange}
                    placeholder={languageController.getFormCopy('placeholder', 'model')}
                    options={model_list != undefined ? selectedOptions : modelOptions}
                  />
                )}
                <FormGroup md={2}>
                  <Input
                    type="text"
                    name="firstname"
                    label={languageController.getFormCopy('label', 'firstname')}
                    value={firstname}
                    isRequired={true}
                    errorMessage={errors.firstname}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  <Input
                    type="text"
                    name="lastname"
                    label={languageController.getFormCopy('label', 'lastname')}
                    value={lastname}
                    isRequired={true}
                    errorMessage={errors.lastname}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </FormGroup>
                <Input
                  type="email"
                  name="email"
                  label={languageController.getFormCopy('label', 'email')}
                  value={email}
                  isRequired={true}
                  errorMessage={errors.email}
                  onChange={handleChange}
                  maxLength={320}
                />
                <FormGroup md={2}>
                  <Input
                    type="text"
                    name="postalcode"
                    label={languageController.getFormCopy('label', 'postalcode')}
                    value={postalcode}
                    isRequired={true}
                    errorMessage={errors.postalcode}
                    onChange={handleChange}
                    maxLength={7}
                  />
                </FormGroup>

                <div className="mz-form-container__disclaimer label label--tight">
                  {formDisclaimer ? parse(formDisclaimer) : ''}
                </div>

                <div className="mz-container-flex">
                    <Button
                      type="submit"
                      className="mz-btn--primary mz-btn--red"
                      label={formSubmitButtonText ? formSubmitButtonText : languageController.getCopy('kmi', 'submit')}
                      submitClass=""
                      // disabled={isDisabled}
                    />
                  </div>
              </Form>
            </FormContainer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KMI
